// import { useEffect, useState } from "react";
// import { useNavigate } from "react-router";
// import { FLEETRIFYROUTEPATH } from "../routes/routesPath";
// import { useLoginMutation } from "../redux/services/authApi";
// import { toast } from "sonner";
// import { useEmailInput } from "../hooks/useEmailInput";
// import { useAppDispatch } from "../redux/services/store";
// import { setAuthUser, clearAuthUser } from "../redux/slices/authSlice";
// import Cookies from "js-cookie";

// // hook for inactivity logout
// export const useInactivityLogout = (timeout = 30 * 60 * 1000) => {
//   useEffect(() => {
//     let timer: NodeJS.Timeout;

//     const resetTimer = () => {
//       clearTimeout(timer);
//       timer = setTimeout(() => {
//         // remove all cookies on inactivity
//         Cookies.remove("fleetrify_token");
//         Cookies.remove("fleetrify_name");
//         Cookies.remove("fleetrify_email");
//         Cookies.remove("fleetrify_role");
//         Cookies.remove("fleetrify_account_type_id");
//         Cookies.remove("fleetrify_user_id");

//         window.location.href = FLEETRIFYROUTEPATH.LOGIN;
//       }, timeout);
//     };

//     window.addEventListener("mousemove", resetTimer);
//     window.addEventListener("keypress", resetTimer);

//     resetTimer();

//     return () => {
//       clearTimeout(timer);
//       window.removeEventListener("mousemove", resetTimer);
//       window.removeEventListener("keypress", resetTimer);
//     };
//   }, [timeout]);
// };

// // login hook
// export const useLoginControllers = () => {
//   const navigate = useNavigate();
//   const dispatch = useAppDispatch();

//   const [showPassword, setShowPassword] = useState(false);
//   const { email, setEmail, isEmailValid, showEmailError } = useEmailInput();
//   const [form, setForm] = useState({ email, password: "", remember: false });

//   useEffect(() => setForm((prev) => ({ ...prev, email })), [email]);

//   const [login, { isLoading }] = useLoginMutation();

//   const handleChange = (value: string, field: keyof typeof form) => {
//     if (field === "email") setEmail(value);
//     setForm((prev) => ({ ...prev, [field]: value }));
//   };

//   const isDisabled = !form.email.trim() || !form.password.trim() || !isEmailValid;

//   const handleSubmit = async (e: React.FormEvent) => {
//     e.preventDefault();
//     try {
//       const response = await login(form).unwrap();

//       // Safely get user & token from response.data
//       const user = response.data?.user;
//       const token = response.data?.token;

//       if (!user || !token) {
//         console.error("User or token not found in response");
//         return;
//       }

//       // login details
//       // console.log("User ID:", user.id);
//       // console.log("User Name:", user.name);
//       // console.log("Login Email:", user.email);
//       // console.log("Login Token:", token);
//       // console.log("Account Type:", user.account_type);

//       const accountTypeFriendly =
//         user.account_type === "01K2MJQX9ZMJPJSAPTG6GVQYF6" ? "company" : "individual";
//       console.log("Account Type Friendly:", accountTypeFriendly);

//       // save to cookie for 7 days
//       Cookies.set("fleetrify_token", token, { expires: 7 });
//       Cookies.set("fleetrify_name", user.name, { expires: 7 });
//       Cookies.set("fleetrify_email", user.email, { expires: 7 });
//       Cookies.set("fleetrify_account_type_id", user.account_type, { expires: 7 });
//       Cookies.set("fleetrify_role", accountTypeFriendly, { expires: 7 });
//       Cookies.set("fleetrify_user_id", user.id, { expires: 7 });

//       localStorage.setItem("userId", String(user.id));
//       localStorage.setItem("userDetails", JSON.stringify(user));


//       // saving to redux
//       dispatch(setAuthUser({ token, user }));

//       // 2fa check
//       if (user.is_2fa_enabled === 1) {
//         navigate(`${FLEETRIFYROUTEPATH.VERIFY_EMAIL}?email=${user.email}`);
//         return;
//       }

//       //navigate to dashboard
//       navigate(FLEETRIFYROUTEPATH.DASHBOARD);
//       // } catch (error: any) {
//       //   if (error?.status === 403) {
//       //     toast.error(error?.data?.message || "Access forbidden.", {
//       //       style: {
//       //         background: "#ffe5e5",
//       //         color: "#ef4444",
//       //         border: "1px solid #ff4d4f",
//       //       },
//       //     });
//       //   } else {
//       //     toast.error(error?.data?.message || "Login failed. Please try again.");
//       //   }
//       //   console.error("Login failed", error);
//       // }

//     } catch (error: any) {
//       const status = error?.status;
//       const message = error?.data?.message;
//       const errors = error?.data?.errors;

//       const toastStyle = {
//         style: {
//           background: "#ffe5e5",
//           color: "#ef4444",
//           border: "1px solid #ff4d4f",
//         },
//       };

//       if (errors) {
//         Object.values(errors).forEach((errorMessages: any) => {
//           if (Array.isArray(errorMessages)) {
//             errorMessages.forEach((msg: string) => toast.error(msg, toastStyle));
//           }
//         });
//       } else if (status === 401) {
//         toast.error("Invalid email or password. Please try again.", toastStyle);
//       } else if (status === 403) {
//         toast.error(message || "Access forbidden.", toastStyle);
//       } else if (status === 422) {
//         toast.error(message || "Invalid credentials.", toastStyle);
//       } else if (status === 429) {
//         toast.error("Too many login attempts. Please wait and try again.", toastStyle);
//       } else {
//         toast.error(message || "Login failed. Please try again.", toastStyle);
//       }

//       console.error("Login failed", error);
//     }
//   };

//   const toggleShowPassword = () => setShowPassword((prev) => !prev);

//   const handleLogout = () => {
//     // remove cookies
//     Cookies.remove("fleetrify_token");
//     Cookies.remove("fleetrify_name");
//     Cookies.remove("fleetrify_email");
//     Cookies.remove("fleetrify_role");
//     Cookies.remove("fleetrify_account_type_id");
//     Cookies.remove("fleetrify_user_id");

//     // clear redux
//     dispatch(clearAuthUser());
//     navigate(FLEETRIFYROUTEPATH.LOGIN);
//   };

//   // apply inactivity logout
//   useInactivityLogout();

//   return {
//     form,
//     isLoading,
//     showPassword,
//     isDisabled,
//     showEmailError,
//     handleSubmit,
//     handleChange,
//     toggleShowPassword,
//     setForm,
//     handleLogout,
//   };
// };



import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import { FLEETRIFYROUTEPATH } from "../routes/routesPath";
import { useLoginMutation } from "../redux/services/authApi";
import { toast } from "sonner";
import { useAppDispatch } from "../redux/services/store";
import { setAuthUser, clearAuthUser } from "../redux/slices/authSlice";
import Cookies from "js-cookie";

// hook for inactivity logout
export const useInactivityLogout = (timeout = 30 * 60 * 1000) => {
  useEffect(() => {
    let timer: NodeJS.Timeout;

    const resetTimer = () => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        Cookies.remove("fleetrify_token");
        Cookies.remove("fleetrify_name");
        Cookies.remove("fleetrify_email");
        Cookies.remove("fleetrify_role");
        Cookies.remove("fleetrify_account_type_id");
        Cookies.remove("fleetrify_user_id");

        window.location.href = FLEETRIFYROUTEPATH.LOGIN;
      }, timeout);
    };

    window.addEventListener("mousemove", resetTimer);
    window.addEventListener("keypress", resetTimer);

    resetTimer();

    return () => {
      clearTimeout(timer);
      window.removeEventListener("mousemove", resetTimer);
      window.removeEventListener("keypress", resetTimer);
    };
  }, [timeout]);
};

// An ACCOUNT_LOCKED response locks that account for Retry-After seconds. The
// lock is kept in localStorage so a page refresh doesn't re-enable the button.
const LOGIN_LOCK_KEY = "fleetrify_login_lock";
const DEFAULT_LOCK_SECONDS = 300;

type LoginLock = { email: string; until: number; message: string };

const readLoginLock = (): LoginLock | null => {
  try {
    const lock = JSON.parse(localStorage.getItem(LOGIN_LOCK_KEY) || "null");
    return lock && lock.until > Date.now() ? lock : null;
  } catch {
    return null;
  }
};

const normalizeEmail = (email: string) => email.trim().toLowerCase();

export const formatCountdown = (seconds: number) =>
  `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, "0")}`;

// login hook
export const useLoginControllers = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const location = useLocation();
  // Pages that send people here (e.g. verify email) can pass the email to fill in.
  const passedEmail: string = (location.state as { email?: string } | null)?.email || '';

  const [showPassword, setShowPassword] = useState(false);
  const [form, setForm] = useState(() => {
    const savedForm = sessionStorage.getItem('loginForm');
    if (savedForm) {
      try {
        const parsed = JSON.parse(savedForm);
        return {
          email: passedEmail || parsed.email || '',
          password: parsed.password || '',
          remember: parsed.remember || false,
        };
      } catch {
        return { email: passedEmail, password: '', remember: false };
      }
    }
    return { email: passedEmail, password: '', remember: false };
  });

  const isValidEmail = (value: string) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);

  // Save form data whenever it changes
  useEffect(() => {
    const formData = {
      email: form.email,
      password: form.password,
      remember: form.remember,
    };
    sessionStorage.setItem('loginForm', JSON.stringify(formData));
  }, [form.email, form.password, form.remember]);

  const [login, { isLoading }] = useLoginMutation();

  const [loginLock, setLoginLock] = useState<LoginLock | null>(readLoginLock);
  const [now, setNow] = useState(() => Date.now());

  // Tick once a second while locked; drop the lock when it runs out.
  useEffect(() => {
    if (!loginLock) return;
    const timer = setInterval(() => {
      const current = Date.now();
      setNow(current);
      if (current >= loginLock.until) {
        setLoginLock(null);
        localStorage.removeItem(LOGIN_LOCK_KEY);
      }
    }, 1000);
    return () => clearInterval(timer);
  }, [loginLock]);

  // The lock is per account, so typing a different email isn't blocked.
  const isLocked =
    !!loginLock &&
    loginLock.until > now &&
    loginLock.email === normalizeEmail(form.email);
  const lockSecondsLeft = isLocked
    ? Math.max(0, Math.ceil((loginLock.until - now) / 1000))
    : 0;

  const handleChange = (value: string, field: keyof typeof form) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const isDisabled =
    !form.email.trim() || !form.password.trim() || !isValidEmail(form.email) || isLocked;

  const toastStyle = {
    style: {
      background: "#ffe5e5",
      color: "#ef4444",
      border: "1px solid #ff4d4f",
    },
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (isLocked) return;

    try {
      const response = await login(form).unwrap();

      const user = response.data?.user;
      const token = response.data?.token;

      if (!user || !token) {
        console.error("User or token not found in response");
        return;
      }

      const rawType = String(user.account_type || "").toLowerCase();
      const accountTypeFriendly: "company" | "individual" =
        rawType === "company" || rawType.startsWith("org") ? "company" : "individual";

      Cookies.set("fleetrify_token", token, { expires: 7 });
      Cookies.set("fleetrify_name", user.name, { expires: 7 });
      Cookies.set("fleetrify_email", user.email, { expires: 7 });
      Cookies.set("fleetrify_account_type_id", user.account_type, { expires: 7 });
      Cookies.set("fleetrify_role", accountTypeFriendly, { expires: 7 });
      Cookies.set("fleetrify_user_id", user.id, { expires: 7 });

      localStorage.setItem("userId", String(user.id));
      localStorage.setItem("userDetails", JSON.stringify(user));

      dispatch(setAuthUser({ token, user }));

      // Clear saved login form on successful login
      sessionStorage.removeItem('loginForm');

      if (user.is_2fa_enabled === 1) {
        navigate(`${FLEETRIFYROUTEPATH.VERIFY_EMAIL}?email=${user.email}`);
        return;
      }

      navigate(FLEETRIFYROUTEPATH.DASHBOARD);

    } catch (error: any) {
      const status = error?.status;
      // Always prefer the server's own wording (it includes attempts left).
      const message = error?.data?.error?.message ?? error?.data?.message;
      const code = error?.data?.error?.code;
      const redirect = error?.data?.error?.redirect;
      const errors = error?.data?.errors;

      if (errors) {
        Object.values(errors).forEach((errorMessages: any) => {
          if (Array.isArray(errorMessages)) {
            errorMessages.forEach((msg: string) => toast.error(msg, toastStyle));
          }
        });
        return;
      }

      // if (code === "EMAIL_NOT_VERIFIED") {
      //   toast.error(message, toastStyle);
      //   navigate(FLEETRIFYROUTEPATH.VERIFY_EMAIL, {
      //     state: {
      //       email: form.email,
      //       mode: "signup",
      //     },
      //   });
      //   return;
      // }
      if (code === "EMAIL_NOT_VERIFIED") {
        toast.error(message, toastStyle);
        setTimeout(() => {
          navigate(FLEETRIFYROUTEPATH.VERIFY_EMAIL, {
            state: {
              email: form.email,
              mode: "signup",
            },
          });
        }, 3000);
        return;
      }

      // if (code === "KYC_NOT_COMPLETED") {
      //   toast.error(message, toastStyle);
      //   if (redirect?.startsWith("http")) {
      //     window.location.href = redirect;
      //   } else {
      //     navigate(redirect ?? FLEETRIFYROUTEPATH.ONBOARDINGINDIVIDUALKYCFORM);
      //   }
      //   return;
      // }
      if (code === "COMPANY_PROFILE_INCOMPLETE") {
        toast.error(message, toastStyle);
        setTimeout(() => {
          if (redirect?.startsWith("http")) {
            window.location.href = redirect;
          } else {
            navigate(redirect ?? FLEETRIFYROUTEPATH.INDIVIDUALPROFILE);
          }
        }, 3000);
        return;
      }

      if (code === "ACCOUNT_LOCKED") {
        const retryAfter = Number(error?.retryAfter);
        const seconds = retryAfter > 0 ? retryAfter : DEFAULT_LOCK_SECONDS;
        const lock: LoginLock = {
          email: normalizeEmail(form.email),
          until: Date.now() + seconds * 1000,
          message:
            message ||
            "Too many incorrect password attempts. This account is locked for a few minutes.",
        };
        localStorage.setItem(LOGIN_LOCK_KEY, JSON.stringify(lock));
        setNow(Date.now());
        setLoginLock(lock);
        return;
      }

      if (status === 401) {
        toast.error(message || "Invalid email or password. Please try again.", toastStyle);
      } else if (status === 403) {
        toast.error(message || "Access forbidden.", toastStyle);
      } else if (status === 451) {
        toast.error(message || "Compliance verification required.", toastStyle);
      } else if (status === 422) {
        toast.error(message || "Invalid credentials.", toastStyle);
      } else if (status === 429) {
        toast.error(message || "Too many login attempts. Please wait and try again.", toastStyle);
      } else {
        toast.error(message || "Login failed. Please try again.", toastStyle);
      }

      console.error("Login failed", error);
    }
  };

  const toggleShowPassword = () => setShowPassword((prev) => !prev);

  const handleLogout = () => {
    Cookies.remove("fleetrify_token");
    Cookies.remove("fleetrify_name");
    Cookies.remove("fleetrify_email");
    Cookies.remove("fleetrify_role");
    Cookies.remove("fleetrify_account_type_id");
    Cookies.remove("fleetrify_user_id");

    dispatch(clearAuthUser());
    navigate(FLEETRIFYROUTEPATH.LOGIN);
  };

  useInactivityLogout();

  return {
    form,
    isLoading,
    showPassword,
    isDisabled,
    isLocked,
    lockSecondsLeft,
    lockMessage: isLocked ? loginLock?.message : undefined,
    handleSubmit,
    handleChange,
    toggleShowPassword,
    setForm,
    handleLogout,
  };
};